<template>
	<div class="site-overlay">
		<div class="site-overlay__card" :class="{ 'is-error': isTranslationFailed }" role="status" aria-live="polite">
			<img class="site-overlay__logo" src="@/assets/images/mh-logo-full.png" alt="Ministry of Municipalities and Housing">

			<!-- loading state -->
			<template v-if="!isTranslationFailed">
				<div class="site-overlay__progress"><span /></div>
				<p class="site-overlay__hint" dir="rtl">جارٍ تحميل المنصة...</p>
				<p class="site-overlay__hint site-overlay__hint--en" dir="ltr">Loading the platform...</p>
			</template>

			<!-- error state: translations are unavailable here, so both languages are hard-coded -->
			<template v-else>
				<div class="site-overlay__icon">
					<v-icon size="38" color="error">mdi-cloud-alert-outline</v-icon>
				</div>

				<div class="site-overlay__message" dir="rtl">
					<h1>تعذّر تحميل المنصة</h1>
					<p>حدث خطأ أثناء الاتصال بالخادم. يرجى إعادة المحاولة، وإذا استمرت المشكلة فتواصل مع مدير النظام.</p>
				</div>

				<div class="site-overlay__divider" />

				<div class="site-overlay__message site-overlay__message--en" dir="ltr">
					<h2>Unable to load the platform</h2>
					<p>We couldn't reach the server. Please try again, and contact the system administrator if the problem persists.</p>
				</div>

				<v-btn class="site-overlay__retry" color="primary" depressed large :loading="retrying" @click="retry">
					<v-icon left>mdi-refresh</v-icon>
					إعادة المحاولة &nbsp;·&nbsp; Retry
				</v-btn>
			</template>
		</div>
	</div>
</template>
<script>
	import { mapGetters } from 'vuex'

	export default {
		data() {
			return {
				retrying: false
			}
		},

		computed: {
			...mapGetters('app', ['isTranslationFailed']),
		},

		methods: {
			retry() {
				this.retrying = true
				window.location.reload()
			}
		}
	}
</script>
<style scoped>
	.site-overlay {
		position: fixed;
		inset: 0;
		z-index: 1000;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 24px 16px;
		background:
			radial-gradient(circle at 15% 20%, rgba(10, 113, 110, 0.10), transparent 45%),
			radial-gradient(circle at 85% 85%, rgba(132, 186, 36, 0.12), transparent 45%),
			#f5f7f7;
		overflow-y: auto;
	}

	.site-overlay__card {
		width: 100%;
		max-width: 480px;
		padding: 40px 36px 32px;
		background: #fff;
		border-radius: 16px;
		border-top: 4px solid var(--v-primary-base);
		box-shadow: 0 10px 40px rgba(16, 42, 41, 0.10), 0 2px 8px rgba(16, 42, 41, 0.06);
		text-align: center;
		animation: overlay-in 0.35s ease-out;
	}

		.site-overlay__card.is-error {
			border-top-color: var(--v-error-base);
		}

	.site-overlay__logo {
		height: 56px;
		max-width: 100%;
		object-fit: contain;
		margin-bottom: 28px;
	}

	/* loading */
	.site-overlay__progress {
		position: relative;
		height: 4px;
		margin: 0 auto 18px;
		max-width: 220px;
		border-radius: 4px;
		background: #e3eeed;
		overflow: hidden;
	}

		.site-overlay__progress span {
			position: absolute;
			top: 0;
			bottom: 0;
			width: 40%;
			border-radius: 4px;
			background: var(--v-primary-base);
			animation: progress-slide 1.2s ease-in-out infinite;
		}

	.site-overlay__hint {
		margin: 0;
		font-size: 15px;
		font-weight: 500;
		color: #3d4f4e;
	}

	.site-overlay__hint--en {
		margin-top: 2px;
		font-size: 13px;
		font-weight: 400;
		color: #7a8b8a;
	}

	/* error */
	.site-overlay__icon {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 72px;
		height: 72px;
		margin-bottom: 20px;
		border-radius: 50%;
		background: rgba(255, 82, 82, 0.10);
	}

	.site-overlay__message h1 {
		margin: 0 0 8px;
		font-size: 22px;
		font-weight: 700;
		color: #1d2b2a;
	}

	.site-overlay__message p {
		margin: 0;
		font-size: 14.5px;
		line-height: 1.7;
		color: #55625f;
	}

	.site-overlay__message--en h2 {
		margin: 0 0 6px;
		font-size: 16px;
		font-weight: 600;
		color: #3d4f4e;
	}

	.site-overlay__message--en p {
		font-size: 13px;
		line-height: 1.6;
		color: #7a8b8a;
	}

	.site-overlay__divider {
		height: 1px;
		margin: 20px auto;
		max-width: 80px;
		background: #e3e8e8;
	}

	.site-overlay__retry {
		margin-top: 28px;
		min-width: 220px;
		border-radius: 10px;
		text-transform: none;
		letter-spacing: 0;
		font-weight: 600;
	}

	@keyframes progress-slide {
		0% { left: -40%; }
		100% { left: 100%; }
	}

	@keyframes overlay-in {
		from { opacity: 0; transform: translateY(8px); }
		to { opacity: 1; transform: none; }
	}

	@media (prefers-reduced-motion: reduce) {
		.site-overlay__card { animation: none; }
		.site-overlay__progress span { animation-duration: 2.4s; }
	}

	@media (max-width: 480px) {
		.site-overlay__card { padding: 32px 20px 24px; }
		.site-overlay__logo { height: 44px; }
	}
</style>
